import { Plus } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IPartFinderAttribute } from 'companySettings/types';
import { Button } from 'core/components';
import { Color } from 'theme/enums';

import { UpsertPartFinderAttribute } from './UpsertPartFinderAttribute';

interface IProps {
  attribute?: IPartFinderAttribute;
  buttonElement?: ReactElement;
}

export const UpsertPartFinderAttributeButton = ({ attribute, buttonElement }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const button = useMemo(() => {
    if (buttonElement) {
      return cloneElement(buttonElement, {
        onClick: () => setIsOpen(true),
      });
    }

    return (
      <Button
        text={t('buttonLabelAddPartFinderAttribute')}
        color={Color.SUCCESS}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
      />
    );
  }, [buttonElement, t]);

  return (
    <>
      {button}

      <UpsertPartFinderAttribute
        attribute={attribute}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};
